import React, { Fragment, useRef } from 'react'
import useOutsideClick from '../../SearchComponent/useOutsideClick'
import useDebouncedSearch from '../../SearchComponent/useDebouncedSearch'

import { fetchResponse } from '../../../controllers/shared/utils/fetch_data'

import SearchResults from './SearchResults'

import './style.scss'

export default function SearchComponent() {
  const searchFunction = async inputText => {
    const sanitizedInputText = encodeURIComponent(inputText)
    const response = await fetchResponse(`/global_search?global_q=${sanitizedInputText}`)

    if (response.ok) {
      return response.json()
    }
  }

  const { inputText, setInputText, searchResults } = useDebouncedSearch(searchFunction)
  const ref = useRef()

  useOutsideClick(ref, () => {
    setInputText('')
  })

  const clearSearch = () => {
    setInputText('')
  }

  return (
    <Fragment>
      <div ref={ref}>
        <div className=''>
          <i className='fas fa-search fa-2x text-grey' />
          <input
            type='text'
            value={inputText}
            onChange={e => setInputText(e.target.value)}
            placeholder='Search by resident, facility, case, incident, activity'
            name='case-search'
            className='border-0 ms-3 search-input-component'
            autoComplete='off'
            aria-label='Search by resident, facility, case, incident, activity'
          />
          {inputText && (
            <i className='fas fa-times position-absolute' onClick={clearSearch} />
          )}
        </div>
        <SearchResults
          inputText={inputText}
          searchResults={searchResults}
        />
      </div>
    </Fragment>
  )
}
